import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router, Routes } from '@angular/router';
import {AuthService } from '../../services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { SUGuard} from 'src/app/guards/su.guard';
import { User} from 'src/app/interfaces/user';
import {FlashMessagesService} from 'angular2-flash-messages';
import { Observable } from 'rxjs';

declare var $: any;
@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.sass']
})
export class NavBarComponent implements OnInit {
 

  constructor(
    public authService: AuthService,
    public flashMessage: FlashMessagesService,
    public userService: UserService,
    public router: Router,
    public guard: SUGuard,
    public http: HttpClient
  ) { 
    
  }

  ngOnInit() {
    $(document).ready(function open() {
      $('.nav-item').on('click',  function(this: HTMLElement) { 
        $('.nav-item').parent().find('li>a.active').removeClass('active'); 
        $(this).find('a').addClass('active');  
      });
    });
  }

}
